<template>
    <div id="patient-assistance-program-queue">
        <card title="Patient Assistance Program Queue">
            <b-row>
                <b-col cols="12" lg="4">
                    <SearchComponent v-model="programFilter" label="Program" 
                                    search-u-r-l="/Program" 
                                    :params="{ active: true }" 
                                    clearable prepopulate />
                </b-col>
                <b-col cols="12" lg="4">
                    <DateRangeFilter v-model="createdDateFilter" 
                                    label="Created Date" />
                </b-col>
                <b-col cols="12" lg="4">
                    <EnumSelector v-model="statusFilter" 
                                 label="Status" 
                                 :enum-codes="PatientAssistanceProgramStatus" 
                                 :clearable="true" />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-checkbox v-model="showAll">Show All</b-form-checkbox>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <patient-assistance-program-table :table-filter="tableFilter"
                        api-url="PatientAssistanceProgram/Queue" />
                </b-col>
            </b-row>
        </card>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { AxiosRequestConfig } from "axios";
import PatientAssistanceProgramTable from "@/components/PatientAssistanceProgram/PatientAssistanceProgramTable.vue";
import SearchComponent from "@/components/SearchComponent.vue";
import DateRangeFilter from "@/components/DateRangeFilter.vue";
import EnumSelector from "@/components/EnumSelector.vue";
import { Program } from "@/models/Program";
import { PatientAssistanceProgramStatus } from "@/models/PatientAssistanceProgram";

@Component({
    name: "PatientAssistanceProgramQueue",
    components: {
        PatientAssistanceProgramTable,
        SearchComponent,
        DateRangeFilter,
        EnumSelector
    }
})
export default class PatientAssistanceProgramQueue extends Vue {
    protected showAll: boolean = false;
    protected programFilter: Program | null = new Program();
    protected createdDateFilter: any = { startDate: "", endDate: "" };
    protected statusFilter: PatientAssistanceProgramStatus | null = null;

    PatientAssistanceProgramStatus = PatientAssistanceProgramStatus;

    get tableFilter(): AxiosRequestConfig {
        let filter: AxiosRequestConfig;
        filter = {
            params: {
                all: this.showAll,
                programId: (this.programFilter?.id ?? 0) > 0 ? this.programFilter?.id : null,
                fromDate: this.createdDateFilter.startDate,
                toDate: this.createdDateFilter.endDate,
                status: this.statusFilter
            }
        };
        return filter;
    }
}
</script>

<style scoped></style>
